import { render, staticRenderFns } from "./KeywordInput.vue?vue&type=template&id=1c06fc68"
import script from "./KeywordInput.vue?vue&type=script&lang=js"
export * from "./KeywordInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports